import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import TrialPlan from "../components/TrialPlan"
import Footer from "../components/footer";
// See the note in pages/pricing.js: this replaces components/navbar.js so the
// whole site shares one header.
import HeaderNano from "./Layouts/header";
import useDarkPage from '../hooks/useDarkPage';

export default function TrialPlanPricing() {

    // false, matching what the prerenderer captured and what every browser ends
    // at. Starting true meant the saved file and the first client render
    // disagreed about the navbar, and hydration threw the page away. Same fault
    // and same fix as src/pages/pricing.js.
    const [hevolvedroid, setIshevolvedroid] = useState(false);

    useEffect(() => {
        const userAgent = navigator.userAgent;
        setIshevolvedroid(userAgent.includes('hevolvedroid'));
    
    
      }, []);
    
    useDarkPage();
    useEffect(() => {


    }, []);


    return (
        <>
         {!hevolvedroid  && <HeaderNano />}
            
            <section style={{ paddingTop: '4rem' }} className="relative mt-4">
                <div className="container relative" >
                    <div className="grid grid-cols-1 text-center ">
                        <div>
                            <h5 className="md:text-4xl text-3xl md:leading-normal leading-normal tracking-wider font-semibold text-white mb-0">Pricing Plans</h5>
                        </div>

                        <ul className="tracking-[0.5px] mb-0 inline-block ">
                            <li className="inline-block capitalize text-[15px] font-medium duration-500 ease-in-out text-white/50 hover:text-white"><Link to="/">Hevolve AI</Link></li>
                            <li className="inline-block text-base text-white/50 mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
                            <li className="inline-block capitalize text-[15px] font-medium duration-500 ease-in-out text-white" aria-current="page">Pricing</li>
                        </ul>
                    </div>
                </div>
            </section>


            <section className="relative md:pb-24 pb-16">

                <div className="container relative ">

                    <TrialPlan />
                </div>

            </section>

            {
                !hevolvedroid && <Footer />
            }

        </>
    )
}